import { createProvider } from '@nvision/services/data-provider';

import type { CustomerFilters } from '../../models';
import * as api from './api';
import { normalizeCustomerFilters, normalizeCustomers } from './normalize';

export const fetchCustomers = createProvider(
  (filters: Partial<CustomerFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchCustomers(normalizeCustomerFilters(filters), { signal }),
).andThen((res) => normalizeCustomers(res));
